// extracted by mini-css-extract-plugin
module.exports = {"container":"BotLoadingMessage_container__i_yPN","bubble":"BotLoadingMessage_bubble__4LFHK"};